module.exports = __webpack_public_path__ + "static/media/wine-bottle.d42148b7.svg";